import { createActionsHook, createContainer, createHook, createStateHook, createStore } from 'react-sweet-state';
import { addPrincipals, removePrincipal, setPrincipals } from './actions';
const initialState = {
  principals: [],
  // Callbacks modified by container init hydration.
  loadRestrictedPrincipals: () => Promise.resolve({
    principals: []
  }),
  saveRestrictedPrincipals: () => Promise.resolve()
};

// Explicitly set actions to export for the store.
const actions = {
  setPrincipals,
  addPrincipals,
  removePrincipal
};
const FormPermissionsStore = createStore({
  name: 'form-permissions-store',
  initialState,
  actions
});
export const FormPermissionsContainer = createContainer(FormPermissionsStore, {
  onInit: () => ({
    setState
  }, {
    loadRestrictedPrincipals,
    saveRestrictedPrincipals
  }) => setState({
    ...initialState,
    loadRestrictedPrincipals,
    saveRestrictedPrincipals
  })
});
export const useFormPermissions = createHook(FormPermissionsStore);
export const useFormPermissionsActions = createActionsHook(FormPermissionsStore);
export const useFormPermissionsState = createStateHook(FormPermissionsStore);